import { useEffect, useState } from "react";

const useFetch = (url) => {
    const [data, setData] = useState(null);
    const [isPending, setIsPending] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

      const abortCont = new AbortController();

        setTimeout(() => {
          fetch(url, {signal: abortCont.signal})
            .then(res => {
              console.log(res);
              if(!res.ok){
                throw Error('cound not find the data for that resource');
              }
              return res.json();
            })
            .then(data =>{
              console.log(data);
              setData(data);
              setIsPending(false); 
              setError(null);
            })
            .catch(err => {
              if(err.name === 'AbortError'){
                console.log("Fetch aborted");
              }
              else{
                setIsPending(false);
                setError(err.message);  
              }
        
            })
        });                                             {/* after , we can add 1000 milisec of delay to show the real fetch requests */}

        return () => abortCont.abort();
      }, [url]);

    return {data, isPending, error}
}

export default useFetch;